import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        justify-content: space-between;
        align-items: start;
        padding-bottom: 16px;
        border-bottom: 1px solid ${({ theme }) => theme.color.grey4};

        & > h2 {
            ${({ theme }) => theme.font.small_bold};
        }
    `,
    "BackBtn": styled.button`
        display: flex;
        align-items: center;
        gap: 8px;
        ${({ theme }) => theme.font.small_bold};
    `,
    "BtnDiv": styled.div`
        width: fit-content;
        display: flex;
        gap: 8px;
    `,
    "A": styled.a`
        width: fit-content;
        height: fit-content;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px 16px;
        background-color: ${({ theme }) => theme.color.major};
        color: ${({ theme }) => theme.color.white};
        ${({ theme }) => theme.font.extra_small_bold};
        border-radius: 8px;
    `,
}